export const getRoot = state => state.get('reports') || state;

export const getSession = state => getRoot(state).get('session');

export const getReport = state => getRoot(state).get('report');

export const isLoading = state => getRoot(state).get('isLoading');

export const isConnecting = state => getRoot(state).get('isConnecting');

export const isExporting = state => getRoot(state).get('isExporting');
